<template>
  <div class="news-detail">
    <div class="flex align-center titleTip">
      <div class="iconBack">
        <img src="@/assets/images/icon-Back.png" class="iconBack" alt=""/>
      </div>
      <div @click="$router.push('/')" class="cursor homeText">首页</div>
      <div class="el-icon-arrow-right"></div>
      <div class="homeLabel cursor" @click="handleRouteTo(noticeType)">{{ getText(noticeType) }}</div>
    </div>
    <div>
      <div class="newsTitle">{{ noticeData.noticeTitle }}</div>
      <div class="newsTimes">发布时间: {{ noticeData.createTime }}</div>
      <div class="newsContent" v-html="noticeData.noticeContent">
      </div>
      <div class="change">
        <p v-if="currentId > 0">
          上一篇: <span @click="change(0)"> {{ previous }} </span>
        </p>
        <p v-if="currentId < newsList.length - 1">
          下一篇: <span @click="change(1)"> {{ next }} </span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/newsDetail.less'
import {noticeDetailAPI, noticeListAPI} from "@/api/home";

export default {
  name: 'index',
  data() {
    return {
      currentId: 0,
      noticeId: '',
      noticeType: '',
      previous: '',
      next: '',
      newsList: [],
      noticeData: {},
    }
  },
  mounted() {
    this.noticeId = this.$route.query.newsId
    this.noticeType = sessionStorage.getItem('type')
    this.getlist(sessionStorage.getItem('type'))
    this.getDetail(this.noticeId)
  },
  methods: {
    // 通知公示列表
    getlist(num) {
      const that = this;
      noticeListAPI(num).then(res => {
        const {code, rows, msg} = res
        if (code === 200) {
          that.newsList = rows
          // 获取索引
          that.currentId = rows.findIndex((item) => item.noticeId === Number(that.noticeId));

          // 改变上一篇下一篇的值
          if (that.currentId >= 1) {
            that.previous = rows[that.currentId - 1].noticeTitle
          }
          if (that.currentId < rows.length - 1) {
            that.next = rows[that.currentId + 1].noticeTitle
          }
        } else {
          that.$message.error(msg || '获取列表失败')
        }
      })
    },
    // 获取详情
    getDetail(id) {
      noticeDetailAPI(id).then(res => {
        const {code, data, msg} = res
        if (code === 200) {
          this.noticeData = data
        } else {
          this.$message.error(msg || '获取详情失败')
        }
      })
    },
    // 上一篇下一篇
    change(val) {
      if (val === 0) {
        this.currentId--
      } else {
        this.currentId++
      }
      this.getDetail(this.newsList[this.currentId].noticeId)
      // 更新路由参数
      this.$router.replace({path: this.$route.path, query: {newsId: this.newsList[this.currentId].noticeId}})
      if (this.currentId >= 1) {
        this.previous = this.newsList[this.currentId - 1].noticeTitle
      }
      if (this.currentId < this.newsList.length - 1) {
        this.next = this.newsList[this.currentId + 1].noticeTitle
      }
      window.scrollTo(0, 0)
    },
    // 当前模块
    getText(num) {
      // 1工作交流,2通知公告,3典型案例,4鉴定服务,5行业动态,6法律法规,7司法鉴定机构查询,8司法鉴定人查询
      switch (num) {
        case '1':
          return '工作交流';
        case '2':
          return '通知公告';
        case '3':
          return '典型案例';
        case '4':
          return '鉴定服务';
        case '5':
          return '行业动态';
        case '6':
          return '法律法规';
        case '7':
          return '司法鉴定机构查询';
        case '8':
          return '司法鉴定人查询';
        case '10':
          return '鉴定人培训';
        default:
          return '';
      }
    },
    // 跳转路由
    handleRouteTo(num) {
      // 1工作交流,2通知公告,3典型案例,4鉴定服务,5行业动态,6法律法规,7司法鉴定机构查询,8司法鉴定人查询
      let path = ''
      switch (num) {
        case '1':
          path = '/news?type=1';
          break;
        case '2':
          path = '/tzgg?type=2';
          break;
        case '3':
          path = '/dxal?type=3';
          break;
        case '4':
          path = '/jdfw?type=4';
          break;
        case '5':
          path = '/hydt?type=5';
          break;
        case '6':
          path = '/flfg?type=6';
          break;
        case '7':
          path = '';
          break;
        case '8':
          path = '';
          break;
        case '10':
          path = '';
          break;
        default:
          path = '/';
      }

      if (!path) return
      this.$router.push(path)
    }
  },

};
</script>

